import { render, staticRenderFns } from "./CauseEdit.vue?vue&type=template&id=56e51abf"
import script from "./CauseEdit.vue?vue&type=script&lang=js"
export * from "./CauseEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports